import enpointLookupAdapter from '../../../infrastructure/helpers/functions/lookup/enpointLookupAdapter';
import IngestionConfig from '../../../types/ingestion/IngestionConfig';
import SelectOption from '../../../infrastructure/types/SelectOption';
import { SelectSearchOption } from 'react-select-search';
import dataSourceHelper from '../../../infrastructure/helpers/functions/common/dataSourceHelper';
import IngestionConfigOption from '../../../types/ingestion/IngestionConfigOption';
import pseudocodeHelper from '../../../infrastructure/helpers/functions/common/pseudocodeHelper';
import lookupHelper from '../../../infrastructure/helpers/functions/lookup/lookupHelper';
import copyArray from '../../../infrastructure/helpers/common/copyArray';
import copyObject from '../../../infrastructure/helpers/common/copyObject';
import operandHelper from '../../../infrastructure/helpers/functions/operand/operandHelper';
import Condition from '../../../types/functions/Condition/Condition';
import Lookup from '../../../types/functions/Lookup';
import Operand from '../../../types/functions/Operand/Operand';
import GlobalModuleConfig from '../../../types/report/GlobalModuleConfig';
import Mode from '../../../types/report/Mode';
import RefDataSource from '../../../types/report/RefDataSource';
import ReportConfig from '../../../types/report/ReportConfig';
import sortingHelper from '../../../infrastructure/helpers/common/sortingHelper';
import IdNameAndNumber from '../../../types/report/IdNameAndNumber';
import { getHightestNumberInCollection } from '../../../infrastructure/helpers/common/collectionOperationHelper';
import UserDefinedFunction from '../../../types/report/UserDefinedFunction';
import { getByConditionReferencesInGlobalConfig } from '../GlobalModule/GlobalModule.Helpers';
import ReportVariable from '../../../types/report/ReportVariable';
import { lookup } from 'dns';
import Component from '../../../types/common/Component';

const createDataSourceOption = (dataSource: IngestionConfig): SelectOption => {
    return {
        text: dataSource.name,
        value: (dataSource.id as number).toString()
    };
};

const lookupTypeOtions: SelectOption[] = [

    { value: false.toString(), text: 'Regular' },
    { value: true.toString(), text: 'Multi Result' }
];

const endpointLookupOption: SelectOption = {
    text: 'Report',
    value: enpointLookupAdapter.specialValue
};


const findReferencedComponentsInLookups = (globalModuleConfig: GlobalModuleConfig,
    reportConfig: ReportConfig,
    globalLookupModuleId: number,
    dataSourcesIds: Set<number>,
    referencedLookups: Lookup[],
    referencedUdfs: UserDefinedFunction[],
    missingDataSourcesMap: Map<number, string>): void => {

    let lookupNumber = globalModuleConfig.lookups.find(x => x.id === globalLookupModuleId)?.number as number;

    let lookupsIds = new Set<number>(reportConfig.lookups.map(x => x.globalLookupModuleId as number));

    let udfsIds = new Set<number>(reportConfig.userDefinedFunctions.map(x => x.globalUDFModuleId as number));

    getReferencesInGlobalConfig(globalModuleConfig, lookupNumber, dataSourcesIds, referencedLookups, referencedUdfs, lookupsIds, udfsIds);

    if (dataSourcesIds.size) {

        let configDataSources: number[] = reportConfig.refDataSources.map(x => x.id);
        configDataSources.push(reportConfig.rawDataSourceId || 0);

        dataSourcesIds.forEach((dataSourceId) => {
            if (!configDataSources.includes(dataSourceId)) {
                let ds = globalModuleConfig.refDataSources.find(x => x.id === dataSourceId);

                missingDataSourcesMap.set(dataSourceId, ds?.name as string);
            }
        });
    }
}


const prepareOptionsFromLookups = (lookups: Lookup[], datasources: IngestionConfigOption[]): SelectSearchOption[] => {

    let options: SelectSearchOption[] = [];
    lookups.forEach((lookup) => {
        let dataSource = dataSourceHelper.getById(datasources as IngestionConfig[], lookup.dataSource2Id as number);
        const name = dataSource?.name || '';
        var displayText = pseudocodeHelper.wrapInBrackets(lookupHelper.getName(lookup, name));
        options.push({
            name: displayText,
            value: displayText,
            items: [{ name: lookup.number.toString(), value: lookup.number.toString() }]
        });
    });

    return options;
}

const getReferencedLookupsIds = (globalLookups: Lookup[]): number[] => {

    let result = new Set<number>();

    globalLookups.forEach((lookup) => {
        operandHelper.proceedWhitCondition(lookup.condition, (operand: Operand) => {
            if (operand.lookupNumber) {
                let referenced = globalLookups?.find(x => x.number === operand.lookupNumber)?.id as number;

                result.add(referenced);
            }
        });
    });

    return Array.from(result);
}

const prepareOptionsFromGlobalLookups = (globalLookups: Lookup[], reportConfigDatasources: RefDataSource[], configLookups: Lookup[]): SelectSearchOption[] => {

    let options: SelectSearchOption[] = [];

    if (!globalLookups || globalLookups.length === 0) {
        return options;
    }

    let datasourceIds = new Set(reportConfigDatasources.map(x => x.id));

    let configLookupsIds = configLookups.map(x => x.globalLookupModuleId);

    let referencedLookups = getReferencedLookupsIds(globalLookups);

    let lookupsMatchingConfigDatasources = globalLookups.filter(x => !configLookupsIds.includes(x.id as number))
        .filter(x => referencedLookups.includes(x.id as number) ||
            (datasourceIds.has(x.dataSource1Id as number) && datasourceIds.has(x.dataSource2Id as number)));

    lookupsMatchingConfigDatasources = lookupsMatchingConfigDatasources.sort((prev, next) => prev.number - next.number);

    lookupsMatchingConfigDatasources.forEach((globalLookup) => {

        let lookupName = `L${globalLookup.number}-${globalLookup.name}`;

        options.push({
            name: lookupName,
            value: globalLookup?.id ? globalLookup.id.toString() : '',
            items: [{ name: lookupName, value: globalLookup?.id ? globalLookup.id.toString() : '' }]
        });
    });

    return options;
}


const prepareWarningMessageOnGlobalLookupAdd = (referencedDataSources: string[], referencedLookups: Lookup[], referencedFunctions?: UserDefinedFunction[]): string => {

    let message = '';

    let missingDataSources = referencedDataSources.map(x => `"${x}"`).join(', ');

    let missingLookups = referencedLookups.map(x => `"${x.name}"`).join(', ');

    let missingFunctions = referencedFunctions?.map(x => `"${x.name}"`)?.join(', ');

    if (missingDataSources || missingLookups || missingFunctions) {

        let dataSourcesMessage = missingDataSources ? `Please add datasources: ${missingDataSources}.\n` : '';

        let lookupsMessage = missingLookups ? `Please add referenced Lookups ${missingLookups}.\n` : '';

        message = `${dataSourcesMessage} ${lookupsMessage}\n\n`;
    }

    return message;
}

const getReferencedGlobalLookups = (reportConfig: ReportConfig, globalConfig: GlobalModuleConfig, lookupId: number): Lookup[] => {

    let lookup = globalConfig.lookups.find(x => x.id === lookupId) as Lookup;

    if (lookup) {

        let results: Lookup[] = [];

        traverseNestedLookups(lookup, globalConfig, reportConfig, results);

        return results;
    }

    return [];
}

const traverseNestedLookups = (lookup: Lookup, globalConfig: GlobalModuleConfig, reportConfig: ReportConfig, results: Lookup[]) => {
    operandHelper.proceedWhitCondition(lookup?.condition as Condition, ((operand: Operand) => {
        if (operand.lookupNumber) {
            let currentLookup = globalConfig.lookups.find(x => x.number === operand.lookupNumber) as Lookup;

            if (currentLookup && (results.length === 0 || (results.length > 0 && !results.find(x => x.id === currentLookup.id)))) {

                let existingInReportConfig = reportConfig.lookups.find(x => x.globalLookupModuleId === currentLookup.id);

                if (!existingInReportConfig) {
                    results.push(copyObject(currentLookup));

                    traverseNestedLookups(currentLookup, globalConfig, reportConfig, results);
                }
            }
        }
    }));
}

const getGlobalConfigReferencedDatasources = (configDataSources: number[], refDataSources: RefDataSource[], lookups: Lookup[]): Map<number, string> => {

    let missingDataSources: Map<number, string> = new Map();

    lookups.forEach((lookup) => {
        if (!configDataSources.includes(lookup.dataSource1Id as number)) {

            let dataSource = refDataSources.find(x => x.id === lookup.dataSource1Id);

            if (dataSource?.id) {
                missingDataSources.set(dataSource?.id as number, dataSource?.name || '');
            }
        }
        if (!configDataSources.includes(lookup.dataSource2Id as number)) {

            let dataSource = refDataSources.find(x => x.id === lookup.dataSource2Id);

            if (dataSource?.id) {

                missingDataSources.set(dataSource?.id as number, dataSource?.name || '');
            }
        }
    });

    return missingDataSources;
}

const prepareLookups = (missingLookups: Lookup[], reportConfig: ReportConfig, mainLookup?: Lookup, oldAndNewNumbers?: Map<number, number>): Lookup[] => {

    if (!oldAndNewNumbers) {
        oldAndNewNumbers = new Map<number, number>();
    }

    let reportConfigLookups = reportConfig.lookups.filter(x => x.globalLookupModuleId !== mainLookup?.globalLookupModuleId);

    let maxNumberInLookups = getHightestNumberInCollection(reportConfigLookups as IdNameAndNumber[]);

    let lookups = prepareMissingLookups(maxNumberInLookups, oldAndNewNumbers, missingLookups);

    if (mainLookup) {

        mainLookup.number = lookups.length + maxNumberInLookups + 1;

        let indexOfLookup = reportConfig.lookups.findIndex(x => x.globalLookupModuleId === mainLookup.globalLookupModuleId) as number;

        let lookupsBeforeTargetLookup = reportConfig.lookups.slice(0, indexOfLookup);

        let lookupsAfterTargetLookup = reportConfig.lookups.slice(indexOfLookup + 1);

        let lookupsBeforeMain = lookupsBeforeTargetLookup.concat(lookups);

        lookups = lookupsBeforeMain.concat(mainLookup).concat(lookupsAfterTargetLookup);
    }

    return lookups;
}

const prepareMissingLookups = (maxNumberInLookups: number, oldAndNewNumbers: Map<number, number>, missingLookups: Lookup[]): Lookup[] => {

    let missingLookupsCopy = copyArray(missingLookups);
    sortingHelper.sortByNumberAsc(missingLookupsCopy as IdNameAndNumber[]);

    missingLookupsCopy.forEach((lookup) => {
        maxNumberInLookups++;

        lookup.globalLookupModuleId = lookup.id as number;

        lookup.id = null;

        lookup.mode = Mode.Global;

        lookup.isReadOnly = true;

        oldAndNewNumbers.set(lookup.number, maxNumberInLookups);

        lookup.number = maxNumberInLookups;
    });

    return missingLookupsCopy;
}


const getReferencesInGlobalConfig = (globalConfig: GlobalModuleConfig,
    number: number,
    dataSourceIds: Set<number>,
    resultLookups: Lookup[],
    resulFunctions: UserDefinedFunction[],
    existingInReportConfigLookupsIds: Set<number>,
    existingInReportConfigUdfsIds: Set<number>,
): void => {

    let lookup = globalConfig.lookups.find(x => x.number === number);

    if (lookup?.condition) {
        getByConditionReferencesInGlobalConfig(globalConfig,
            lookup.condition,
            resultLookups,
            resulFunctions,
            dataSourceIds,
            existingInReportConfigLookupsIds,
            existingInReportConfigUdfsIds
        );
    }
};

const updateLookupToLookupReferences = (lookup: Lookup, globalModule: GlobalModuleConfig, reportConfig: ReportConfig): void => {

    operandHelper.proceedWhitCondition(lookup.condition, (operand: Operand) => {
        if (operand.lookupNumber) {

            let globalLookup = globalModule.lookups.find(x => x.number === operand.lookupNumber) as Lookup;

            let reportConfigLookup = reportConfig.lookups.find(x => x.globalLookupModuleId === globalLookup.id);

            if (reportConfigLookup) {
                operand.lookupNumber = reportConfigLookup.number;
            }
        }
    });
}

export {
    createDataSourceOption,
    lookupTypeOtions,
    endpointLookupOption,
    prepareOptionsFromLookups,
    prepareOptionsFromGlobalLookups,
    prepareWarningMessageOnGlobalLookupAdd,
    getReferencedGlobalLookups,
    prepareLookups,
    getGlobalConfigReferencedDatasources,
    getReferencesInGlobalConfig,
    findReferencedComponentsInLookups,
    updateLookupToLookupReferences
};